var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "contact-list-item",
      class: {
        active: _vm.isActive,
        unreaded: _vm.contact.unread,
      },
      on: {
        click: _vm.clickConversation,
        contextmenu: function ($event) {
          $event.preventDefault()
          return _vm.onContextMenu.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "avatar-section" }, [
        _c(
          "div",
          { staticClass: "contact-avatar-wrapper" },
          [
            _c("ContactAvatar", {
              attrs: { contact: _vm.contact, badge: false, size: "small" },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom-end",
                      delay: [300, 0],
                    },
                    expression:
                      "{ followCursor: true, placement: 'bottom-end', delay: [300, 0] }",
                  },
                ],
                staticClass: "platform-badge",
                attrs: { content: _vm.platformTooltip },
              },
              [
                _c("PlatformIcon", {
                  attrs: {
                    platform: _vm.channelType,
                    size: 10,
                    "tippy-disabled": true,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-section" },
        [
          _c("div", { staticClass: "contact-name" }, [
            _vm._v(
              "\n                " + _vm._s(_vm.fullname) + "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("ContactLastMessage", {
            attrs: { lastMessage: _vm.contact.lastMessage },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "status-section" }, [
        _vm.contact.vipCustomer
          ? _c("div", { staticClass: "vip-indicator" }, [
              _c(
                "i",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                        delay: [300, 0],
                      },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end', delay: [300, 0] }",
                    },
                  ],
                  staticClass: "material-icons vip-star",
                  attrs: { content: "★ VIP Customer" },
                },
                [_vm._v("\n                    star\n                ")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "timestamp-wrapper" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "bottom-end" },
                  expression: "{ followCursor: true, placement: 'bottom-end' }",
                },
              ],
              staticClass: "chat-timestamp",
              attrs: { content: _vm.fullTime },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.displayTime) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.contact.unread
            ? _c(
                "div",
                { staticClass: "unread-bagde-container" },
                [_c("MessagesUnreadBagde")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "chat-owner-text",
              class:
                ((_obj = {}), (_obj[_vm.getChatOwnerStatus()] = true), _obj),
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.getChatOwnerText()) +
                  "\n                "
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }